const CONSTANTS = require('../../../lib/constants');
const utils = require('../../../lib/utils')

module.exports = {

	// editor instance of jsonEditor
	_editor: null,

	config: {
		focusAble: true,
		focusPriority: 501
	},

	model: {
		html: '',
		routes: [],
		files: []
	},

	events: {
		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function (event) {
				switch (utils.keyboard.getKeyCode(event)) {
					case 'enter':
					case 'esc':
						event.stopImmediatePropagation();
						break;
				}
			}
		}
	},

	methods: {

		/**
		 * get html-editor-button contents
		 */
		dataDealer: function(){
			this.model.html = '';
			this.closest('base_form_fields_html-editor-button', function(component){
				this.model.html = component.model.dataTEXT || '';
			});
		},

		/**
		 * sanitize route data
		 */
		sanitizeResources: function(){
			// init
			this.model.files = [];
			var self = this;

			if(this.resourceData && (this.resourceData.files || {}).data){
				utils.forEach(this.resourceData.files.data, function(media, mediaIndex){
					self.model.files.push({
						depth:  1,
						title:  media.attributes.originalName,
						id:     media.attributes.id || media.attributes.mediaID
					});
				});
			}
		},

		/**
		 * this function is used to return the actual editors content
		 *
		 * @returns html
		 */
		getEditorContent: function(){
			return (this.model.html = (this._editor.getData()).replace(/&nbsp;/gi,' '));
		},

		/**
		 * this function is used to add a new tree to the this trees object.
		 *
		 * @param   treeIndex       int - treeIndex - this is used to map the resourceData for the tree within the resourceRegister.
		 * @param   treeType        string - treeType identifier
		 *                          NOTE:   this treeType is the key within the resourceData.tree identifying the treeComponentType
		 *                                  which can overwrite the tree component which should be used for one tree.
		 * @returns Promise - addTree operation done
		 */
		addRoutePickerButton: function(){
			return this.performAndStoreAction(
				undefined,
				this.prepareAction(
					{
						type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
						source: {
							load: {
								componentData: {
									component: [
										'/',
										'base',
										'form',
										'fields',
										'route-picker-button'
									]
								},
							}
						},
						target: {
							position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.BEFORE,
							element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF
						}
					}
				)
			);
		}
	},

	hooks: {
		attach: function($element, options){
			try {
				if(!options.refresh) {
					// show plugins
					// console.log('PLUGINS', globalThis.CKEDITOR.config.plugins);

					this._editor = globalThis.CKEDITOR.replace($element[0], {
						// Define changes to default configuration here.
						// For complete reference see:
						// http://docs.ckeditor.com/#!/api/CKEDITOR.config

						// https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/configuration.html

						// The toolbar groups arrangement, optimized for two toolbar rows.
						toolbarGroups: [
							{name: 'clipboard', groups: ['clipboard', 'undo']},
							{name: 'editing', groups: ['find', 'selection', 'spellchecker']},
							{name: 'links'},
							{name: 'insert'},
							{name: 'tools'},
							{name: 'document', groups: ['mode', 'document', 'doctools']},
							'/',
							{name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
							{name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'colorButton']},
							{name: 'colors'},
							{name: 'colorButton'},
						],

						// Remove some buttons provided by the standard plugins, which are
						// not needed in the Standard(s) toolbar.
						removeButtons: 'Subscript,Superscript',
						extraAllowedContent: 'p[class],span[class]',

						// Set the most common block elements.
						format_tags: 'p;h1;h2;h3;pre',

						// Simplify the dialog windows.
						removeDialogTabs: 'image:advanced;link:advanced',

						// wt: use this config and don't include file
						customConfig: '',

						// wt: use this config and don't include file
						defaultLanguage: 'de',

						height: 'calc(100% - 104px)',

						cmsFilesForLinkEditor: this.model.files
					});
				}

				// set data of editor
				this._editor.element.setHtml(this.model.html);

				// init routePickerButton
				this.addRoutePickerButton();
			} catch (error) {
				// this catch is used to prevent modal dependent stalling when an error occurs during ckeditor load.
				console.error(error);
			}
		}
	}
};